<div class="ai-popover">
  <mat-form-field appearance="outline" class="ai-popover__textarea-field">
    <mat-label>Leírás</mat-label>
    <textarea
      matInput
      rows="6"
      class="description-textarea"
      [formControl]="descriptionControl"
      placeholder=""
    ></textarea>
  </mat-form-field>

  <div *ngIf="generatedDescriptions.length > 0" class="ai-popover__navigation">
    <button
      type="button"
      mat-icon-button
      class="ai-popover__nav-button"
      (click)="showPreviousDescription()"
      [disabled]="
        isLoading ||
        generatedDescriptions.length <= 1 ||
        currentDescriptionIndex === 0
      "
      aria-label="Előző változat"
    >
      <lucide-icon name="chevron-left" [size]="18" aria-hidden="true"></lucide-icon>
    </button>

    <span class="ai-popover__navigation-indicator">
      {{ currentDescriptionIndex + 1 }}/{{ generatedDescriptions.length }}
    </span>

    <button
      type="button"
      mat-icon-button
      class="ai-popover__nav-button"
      (click)="showNextDescription()"
      [disabled]="
        isLoading ||
        generatedDescriptions.length <= 1 ||
        currentDescriptionIndex === generatedDescriptions.length - 1
      "
      aria-label="Következő változat"
    >
      <lucide-icon name="chevron-right" [size]="18" aria-hidden="true"></lucide-icon>
    </button>
  </div>

  <div class="ai-popover__actions">
    <button
      type="button"
      mat-stroked-button
      class="ai-popover__action-button"
      (click)="onFindClick()"
      [disabled]="isLoading"
    >
      <span class="ai-popover__button-content">
        <lucide-icon name="sparkles" [size]="18" aria-hidden="true"></lucide-icon>
        <span>Lepj meg</span>
      </span>
      <div *ngIf="isFinding" class="ai-popover__loading-bar">
        <span class="ai-popover__loading-bar-indicator"></span>
      </div>
    </button>

    <button
      type="button"
      mat-stroked-button
      class="ai-popover__action-button"
      (click)="onRewriteClick()"
      [disabled]="isLoading"
    >
      <span class="ai-popover__button-content">
        <lucide-icon name="wand-2" [size]="18" aria-hidden="true"></lucide-icon>
        <span>Átfogalmazás</span>
      </span>
      <div *ngIf="isRewriting" class="ai-popover__loading-bar">
        <span class="ai-popover__loading-bar-indicator"></span>
      </div>
    </button>
  </div>

  <div class="ai-popover__footer">
    <button type="button" mat-button (click)="onCloseClick()">
      Bezárás
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      (click)="onAcceptClick()"
      [disabled]="isLoading"
    >
      Elfogad
    </button>
  </div>
</div>
